import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TurnosComponent } from "./turnos.component";

@Component({
    selector: "eliminar-turnos",
    templateUrl: "./turnos-eliminar.component.html",
    styleUrls: [],
    standalone: false
})
export class TurnosEliminarComponent {
  constructor(
    public dialogRef: MatDialogRef<TurnosComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar
  ) {}

  delete() {
    this.dialogRef.close(true);
  }

  closeDialog() {
    this.dialogRef.close(false);
  }
}
